<template>
  <div
    v-if="isOpen"
    class="aff-wd-backdrop"
    tabindex="-1"
    role="dialog"
    @click.self="dismiss"
  >
    <div class="aff-wd-modal" role="document">
      <div class="aff-wd-header">
        <div class="aff-wd-icon">
          <i class="material-icons">account_balance_wallet</i>
        </div>
        <div>
          <p class="aff-wd-eyebrow mb-0">Saldo de afiliado</p>
          <h5 class="mb-0 text-white">Você já pode solicitar saque</h5>
        </div>
      </div>
      <div class="aff-wd-body">
        <p class="aff-wd-lead">
          Seu saldo disponível é
          <strong>{{ formatCurrency(balance) }}</strong>.
          O mínimo para saque é <strong>R$ 100,00</strong>.
        </p>
        <p class="aff-wd-hint">
          Solicite o Pix em Meus Indicados (programa de afiliados). Não usa a
          Carteira do Sistema.
        </p>
        <div class="d-flex flex-column gap-2">
          <button type="button" class="btn aff-wd-btn mb-0" @click="goWallet">
            Ir para Meus Indicados
          </button>
          <button type="button" class="btn btn-outline-secondary mb-0" @click="dismiss">
            Depois
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AffiliateWithdrawPromptModal",
  props: {
    isOpen: { type: Boolean, default: false },
    balance: { type: Number, default: 0 },
  },
  methods: {
    formatCurrency(value) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(value || 0);
    },
    dismiss() {
      try {
        sessionStorage.setItem("seen_affiliate_withdraw_prompt", "1");
      } catch (e) {
        /* ignore */
      }
      this.$emit("close");
    },
    goWallet() {
      this.dismiss();
      this.$router.push({ path: "/meus-indicados", hash: "#saque-afiliado" });
    },
  },
};
</script>

<style scoped>
.aff-wd-backdrop {
  position: fixed;
  inset: 0;
  z-index: 10040;
  background: rgba(15, 23, 42, 0.48);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}
.aff-wd-modal {
  width: min(440px, 100%);
  background: #fff;
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.28);
}
.aff-wd-header {
  display: flex;
  gap: 0.75rem;
  align-items: center;
  padding: 1.15rem 1.25rem;
  background: linear-gradient(145deg, #1f1b17 0%, #2c241c 100%);
}
.aff-wd-icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  background: rgba(212, 181, 106, 0.22);
  color: #f0dfad;
  display: flex;
  align-items: center;
  justify-content: center;
}
.aff-wd-eyebrow {
  font-size: 0.68rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(240, 223, 173, 0.85);
}
.aff-wd-body {
  padding: 1.25rem;
}
.aff-wd-lead {
  font-size: 0.95rem;
  color: #334155;
  margin-bottom: 0.65rem;
}
.aff-wd-hint {
  font-size: 0.82rem;
  color: #64748b;
  margin-bottom: 1.1rem;
}
.aff-wd-btn {
  background: linear-gradient(90deg, #8d6b2c, #d4b56a 55%, #f0dfad) !important;
  color: #1f1b17 !important;
  font-weight: 800 !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 0.7rem 1rem !important;
}
.gap-2 {
  gap: 0.5rem;
}
</style>
